import React, { useState, useEffect,useRef } from 'react';
  import {
    CheckCircle, XCircle, Clock, Eye, X, FileText, User,
    Building, Calendar, Package, AlertCircle, RefreshCw,
    ChevronDown, ChevronUp, MessageSquare, Send, Info, Check
  } from 'lucide-react';
  import API_BASE_URL from "../config";

  // Mock Swal for demo
  const Swal = {
    fire: async (options) => {
      console.log('Swal:', options);
      return { isConfirmed: true };
    }
  };

  const SecondPR_Approval = () => {
    const [prList, setPrList] = useState([]);
    const [filteredPRs, setFilteredPRs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedPR, setSelectedPR] = useState(null);
    const [prDetails, setPrDetails] = useState([]);
    const [prApprovals, setPrApprovals] = useState([]);
    const [allApprovals, setAllApprovals] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentUser, setCurrentUser] = useState(null);
    const [debugInfo, setDebugInfo] = useState(null);

    const [paymentMethods, setPaymentMethods] = useState({});
    const [priorities, setPriorities] = useState({});
    // Approval states
    const [approvalAction, setApprovalAction] = useState(null);
    const [remarks, setRemarks] = useState('');
    const [submitting, setSubmitting] = useState(false);

    // Permission states
    const [canApprovePR, setCanApprovePR] = useState(false);
    const [denialReason, setDenialReason] = useState("");

    // Master data
    const [companies, setCompanies] = useState({});
    const [users, setUsers] = useState({});
    const [departments, setDepartments] = useState({});
    const [approverSignatures, setApproverSignatures] = useState({});
    const [approverDetails, setApproverDetails] = useState({});

    // ✅ States for endorsement requestor selection
    const [requestorList, setRequestorList] = useState([]);
    const [endorsementRequestor, setEndorsementRequestor] = useState(null);
    const [requestorSearch, setRequestorSearch] = useState('');
    const [showRequestorDropdown, setShowRequestorDropdown] = useState(false);

    const dropdownRef = useRef(null);

    // Handle click outside dropdown
    useEffect(() => {
      const handleClickOutside = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
          setShowRequestorDropdown(false);
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
      const user = JSON.parse(localStorage.getItem("user") || '{"id":1,"firstName":"Demo","lastName":"User","positionId":"Endorsement"}');
      console.log("🔍 Current User:", user);
      setCurrentUser(user);
      fetchMasterData();
      fetchPRForApproval(user);
    }, []);

    useEffect(() => {
      filterPRs();
    }, [searchTerm, prList]);

    const fetchMasterData = async () => {
      try {
        const [companiesRes, usersRes, deptRes] = await Promise.all([
          fetch(`${API_BASE_URL}api/Company`),
          fetch(`${API_BASE_URL}api/Users`),
          fetch(`${API_BASE_URL}api/Department`)
        ]);

        const companiesData = await companiesRes.json();
        const usersData = await usersRes.json();
        const deptData = await deptRes.json();

        setCompanies(Object.fromEntries(companiesData.map(c => [c.id, c.companyName || c.CompanyName])));
        setUsers(Object.fromEntries(usersData.map(u => [u.id, `${u.firstName} ${u.lastName}`])));
        setDepartments(Object.fromEntries(deptData.map(d => [d.id, d.departmentName])));
      } catch (err) {
        console.error('Error fetching master data:', err);
      }
    };

    const getCurrentPendingLevel = (approvals) => {
      console.log("📊 Calculating pending level for approvals:", approvals);

      const level2Approval = approvals.find(a => a.approvalLevel === 2);
      const level2Approved = level2Approval?.response === 1;

      const level3Approval = approvals.find(a => a.approvalLevel === 3);
      const level3Approved = level3Approval?.response === 1;

      console.log("✅ Level 2 (Endorsement) approved:", level2Approved);
      console.log("✅ Level 3 (Acknowledgement) approved:", level3Approved);

      if (!level2Approved) {
        console.log("🎯 Current Stage: Level 2 - ENDORSEMENT (PENDING)");
        return 2;
      }

      if (level2Approved && !level3Approved) {
        console.log("🎯 Current Stage: Level 3 - ACKNOWLEDGEMENT (PENDING)");
        return 3;
      }

      console.log("🎯 Current Stage: FULLY APPROVED");
      return 4;
    };

    const getPRPendingLevel = (prId) => {
      const prApprovalsList = allApprovals.filter(a => a.prHeaderId === prId);
      return getCurrentPendingLevel(prApprovalsList);
    };

    const fetchPRForApproval = async (user) => {
      try {
        setLoading(true);

        const response = await fetch(`${API_BASE_URL}api/PR_Header`);
        if (!response.ok) throw new Error('Failed to fetch PR headers');
        const allPRs = await response.json();

        const approvalsRes = await fetch(`${API_BASE_URL}api/SecondApproverPR`);
        const approvalsList = await approvalsRes.json();
        setAllApprovals(approvalsList);

        console.log("📦 All PRs:", allPRs.length);
        console.log("✅ All Approvals:", approvalsList.length);

        const eligiblePRs = allPRs;

        // ✅ SORT BY DateSubmittedForApproval - NEWEST FIRST!
        const sortedPRs = [...eligiblePRs].sort((a, b) => {
          const dateA = new Date(a.dateSubmittedForApproval || a.creationDate || 0).getTime();
          const dateB = new Date(b.dateSubmittedForApproval || b.creationDate || 0).getTime();
          return dateB - dateA;  // ✅ Descending order (newest first)
        });

        console.log("📊 Sorted PRs by DateSubmittedForApproval (newest first)");

        const debug = {
          totalPRs: allPRs.length,
          userPosition: user.positionId,
          eligibleCount: sortedPRs.length,
        };

        console.log("📊 Debug Info:", debug);
        setDebugInfo(debug);
        setPrList(sortedPRs);  // ✅ Use sorted list
        setFilteredPRs(sortedPRs);  // ✅ Use sorted list

      } catch (err) {
        console.error("💥 Error fetching PRs:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    const fetchPRDetails = async (prHeaderId) => {
      try {
        console.log("🔍 Fetching PR Details for ID:", prHeaderId);
        const response = await fetch(`${API_BASE_URL}api/PR_Details/PRHeader/${prHeaderId}`);
        if (!response.ok) throw new Error('Failed to fetch PR details');
        const data = await response.json();
        console.log("✅ PR Details Response:", data);

        const detailsArray = Array.isArray(data) ? data : [data];
        console.log("📋 Setting PR Details:", detailsArray);
        setPrDetails(detailsArray);
      } catch (err) {
        console.error('Error fetching PR details:', err);
        setPrDetails([]);
      }
    };

    const fetchPRApprovals = async (prHeaderId) => {
      try {
        console.log("🔍 Fetching approvals for PR:", prHeaderId);
        const res = await fetch(`${API_BASE_URL}api/SecondApproverPR`);
        const data = await res.json();
        console.log("📦 All approval data:", data);

        const prSpecificApprovals = data.filter(approval => approval.prHeaderId === prHeaderId);
        console.log("✅ PR-specific approvals:", prSpecificApprovals);

        setPrApprovals(prSpecificApprovals);

        const uniqueApproverIds = [...new Set(prSpecificApprovals.map(a => a.actualApproverId).filter(Boolean))];

        for (const userId of uniqueApproverIds) {
          await fetchUserDetails(userId);
          await fetchUserSignature(userId);
        }
      } catch (error) {
        console.error('Error fetching PR approvals:', error);
        setPrApprovals([]);
      }
    };

    const fetchUserSignature = async (userId) => {
      try {
        const res = await fetch(`${API_BASE_URL}api/Users/${userId}/digitalsign`);
        if (res.ok) {
          const blob = await res.blob();
          const imageUrl = URL.createObjectURL(blob);
          setApproverSignatures(prev => ({
            ...prev,
            [userId]: imageUrl
          }));
        }
      } catch (error) {
        console.error(`Error fetching signature for user ${userId}:`, error);
      }
    };

    const fetchUserDetails = async (userId) => {
      try {
        const res = await fetch(`${API_BASE_URL}api/Users/${userId}`);
        if (res.ok) {
          const data = await res.json();
          setApproverDetails(prev => ({
            ...prev,
            [userId]: data
          }));
        }
      } catch (error) {
        console.error(`Error fetching user details for ${userId}:`, error);
      }
    };

    const signatureSlots = selectedPR ? [
      {
        level: 1,
        position: 'Requestor',
        userId: selectedPR.createdBy,
        name: users[selectedPR.createdBy] || 'Requestor',
        date: selectedPR.creationDate,
        signature: approverSignatures[selectedPR.createdBy]
      },
      {
        level: 2,
        position: 'Endorsement',
        approval: prApprovals.find(a => a.approvalLevel === 2 && (a.response === 1 || a.response === 0)),
        selectedRequestor: endorsementRequestor
      },
      {
        level: 3,
        position: 'Acknowledgement',
        approval: prApprovals.find(a => a.approvalLevel === 3 && (a.response === 1 || a.response === 0))
      }
    ] : [];

    const checkPRApprovalPermission = (approvalsList = prApprovals) => {
      try {
        const userSession = localStorage.getItem("user");
        if (!userSession) {
          console.log("❌ No user session found");
          setCanApprovePR(false);
          setDenialReason("No user session found");
          return;
        }

        const sessionData = JSON.parse(userSession);
        const positionId = sessionData.positionId;
        const currentUserId = sessionData.id || sessionData.userId;

        console.log("🔍 ==================== PERMISSION CHECK START ====================");
        console.log("👤 Current User Position:", positionId);
        console.log("🆔 Current User ID:", currentUserId);
        console.log("📋 Approvals List Length:", approvalsList.length);

        const userLevel = 3;

        console.log("🎯 User Approval Level:", userLevel);

        const userPreviousResponse = approvalsList.find(
          approval =>
            approval.actualApproverId === currentUserId &&
            approval.approvalLevel === userLevel
        );

        if (userPreviousResponse) {
          if (userPreviousResponse.response === 1) {
            console.log("❌ DENIED: User already approved this PR at Level", userLevel);
            setCanApprovePR(false);
            setDenialReason("You have already approved this Purchase Request");
            return;
          }

          if (userPreviousResponse.response === 0) {
            console.log("❌ DENIED: User already rejected this PR at Level", userLevel);
            setCanApprovePR(false);
            setDenialReason("You have already rejected this Purchase Request");
            return;
          }
        }

        const currentPendingLevel = getCurrentPendingLevel(approvalsList);
        console.log("📊 Current Pending Level:", currentPendingLevel);
        console.log("📊 User Level:", userLevel);

        if (userLevel < currentPendingLevel) {
          console.log("❌ DENIED: User level is lower than current pending level");
          setCanApprovePR(false);
          const levelNames = { 2: 'Endorsement', 3: 'Acknowledgement' };
          setDenialReason(
            `This request is currently at Level ${currentPendingLevel} (${levelNames[currentPendingLevel]}). ` +
            `Your level (${userLevel}) cannot approve this request.`
          );
          return;
        }

        if (userLevel >= currentPendingLevel) {
          console.log("✅ PERMISSION GRANTED: User level is equal or higher than pending level");
          
          if (userLevel > currentPendingLevel) {
            console.log(`🔥 HIGHER AUTHORITY: Level ${userLevel} can auto-approve Level ${currentPendingLevel}`);
          }

          setCanApprovePR(true);
          setDenialReason("");
          return;
        }

        if (currentPendingLevel === 4) {
          console.log("❌ DENIED: PR is fully approved");
          setCanApprovePR(false);
          setDenialReason("This Purchase Request has already been fully approved");
          return;
        }

        console.log("✅ ==================== PERMISSION GRANTED ====================");
        setCanApprovePR(true);
        setDenialReason("");

      } catch (error) {
        console.error('❌ ERROR:', error);
        setCanApprovePR(false);
        setDenialReason("Error checking approval permissions");
      }
    };

    const filterPRs = () => {
      let filtered = [...prList];

      if (searchTerm) {
        filtered = filtered.filter(pr =>
          pr.prNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (companies[pr.companyId] || '').toLowerCase().includes(searchTerm.toLowerCase())
        );
      }

      // ✅ Maintain sorting by DateSubmittedForApproval after filtering
      filtered.sort((a, b) => {
        const dateA = new Date(a.dateSubmittedForApproval || a.creationDate || 0).getTime();
        const dateB = new Date(b.dateSubmittedForApproval || b.creationDate || 0).getTime();
        return dateB - dateA;  // ✅ Newest first
      });

      setFilteredPRs(filtered);
    };

    const handleViewDetails = async (pr) => {
      console.log("👁️ Opening modal for PR:", pr.id);
      setSelectedPR(pr);
      setPrDetails([]);
      setPrApprovals([]);
      setShowModal(true);
      setCanApprovePR(false);
      setDenialReason("");
      setEndorsementRequestor(null);
      setRequestorSearch('');

      const fetchRequestors = async () => {
        try {
          const res = await fetch(`${API_BASE_URL}api/Requestor`);
          const data = await res.json();
          setRequestorList(data);
        } catch (err) {
          console.error('Error fetching requestors:', err);
        }
      };

      await Promise.all([
        fetchPRDetails(pr.id),
        fetchRequestors(),
        fetchPRApprovals(pr.id)
      ]);
    };

    useEffect(() => {
      if (selectedPR) {
        console.log("🔄 Checking permissions for PR:", selectedPR.id);
        console.log("📋 Current prApprovals:", prApprovals);
        checkPRApprovalPermission(prApprovals);
      }
    }, [selectedPR, prApprovals]);

    const closeModal = () => {
      setShowModal(false);
      setSelectedPR(null);
      setPrDetails([]);
      setPrApprovals([]);
      setApprovalAction(null);
      setRemarks('');
      setCanApprovePR(false);
      setDenialReason("");
      setEndorsementRequestor(null);
      setRequestorSearch('');
      setShowRequestorDropdown(false);
    };

    // ✅ FIXED: handleApprovalSubmit with proper endorsement requestor handling
    const handleApprovalSubmit = async () => {
      if (!approvalAction) {
        await Swal.fire({
          icon: "warning",
          title: "Action Required",
          text: "Please select Approve or Disapprove"
        });
        return;
      }

      if (approvalAction === 'disapprove' && !remarks.trim()) {
        await Swal.fire({
          icon: "warning",
          title: "Remarks Required",
          text: "Please provide remarks for disapproval"
        });
        return;
      }

      try {
        setSubmitting(true);

        const userSession = JSON.parse(localStorage.getItem("user"));
        const currentUserId = userSession.id || userSession.userId;
        const userName = `${userSession.firstName} ${userSession.lastName}`;

        const userLevel = 3;
        console.log("🎯 User Level:", userLevel, "Position:", userSession.positionId);

        // ✅ HIGHER AUTHORITY LOGIC - Auto-approve lower levels with SELECTED ENDORSOR
        if (approvalAction === 'approve') {
          console.log("🔥 HIGHER AUTHORITY DETECTED - Auto-approving Level 2!");

          const existingLevel2 = prApprovals.find(a => a.approvalLevel === 2);

          if (!existingLevel2 || existingLevel2.response !== 1) {
            // ✅ CHECK IF ENDORSER WAS SELECTED (MOST IMPORTANT FIX!)
            if (!endorsementRequestor) {
              await Swal.fire({
                icon: "warning",
                title: "Endorser Required",
                text: "Please select an Endorser (Level 2) from the dropdown before approving"
              });
              setSubmitting(false);
              return;
            }

            console.log("📝 Using SELECTED ENDORSEMENT REQUESTOR...");

            try {
              const endorsementUser = endorsementRequestor;
              console.log("✅ Endorsement Requestor Found:", endorsementUser);

              // ✅ Build Level 2 approval using the SELECTED endorsor
              const level2Data = {
                prHeaderId: selectedPR.id,
                approverUserLevelId: 2,
                actualApproverId: endorsementUser.userId || endorsementUser.id,
                actualApproverName: endorsementUser.name || `${endorsementUser.firstName || ''} ${endorsementUser.lastName || ''}`.trim(),
                response: 1,
                responseDate: new Date().toISOString(),
                responseRemarks: `Auto-approved by ${userName} (Level 3 - Acknowledgement) | Selected Endorsor: ${endorsementUser.name || endorsementUser.id}`,
                approvalLevel: 2
              };

              console.log("📤 Auto-approving Level 2 with SELECTED ENDORSOR:", level2Data);

              const level2Res = await fetch(`${API_BASE_URL}api/SecondApproverPR`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(level2Data)
              });

              if (!level2Res.ok) {
                const errorText = await level2Res.text();
                console.error("❌ Level 2 Auto-Approval Failed:", errorText);
                throw new Error(`Failed to auto-approve Level 2: ${errorText}`);
              }

              const level2Result = await level2Res.json();
              console.log("✅ Level 2 Auto-Approved successfully with SELECTED ENDORSOR:", level2Result);

              // ✅ Log auto-approval of Level 2
              await fetch(`${API_BASE_URL}api/Logs`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  action: "AUTO-APPROVE",
                  module: "Purchase Request",
                  description: `Auto-approved PR #${selectedPR.id} at Level 2 (Endorsement) by ${userName} (Level 3 - Acknowledgement) | Selected Endorsor: ${endorsementUser.name || endorsementUser.id}`,
                  userId: userSession.id || userSession.userId,
                  username: userSession.username,
                  fullName: userName || userSession.username,
                }),
              }).catch((err) => console.error("Log failed:", err));

            } catch (err) {
              console.error("❌ Error in auto-approval process:", err);
              await Swal.fire({
                icon: "error",
                title: "Auto-Approval Failed",
                text: err.message || "Could not complete auto-approval. Please try again."
              });
              setSubmitting(false);
              return;
            }
          } else {
            console.log("✅ Level 2 already approved - skipping auto-approval");
          }
        }

        // ✅ Submit current user's approval (Level 3)
        const approvalData = {
          prHeaderId: selectedPR.id,
          approverUserLevelId: 1,
          actualApproverId: currentUserId,
          actualApproverName: userName,
          response: approvalAction === 'approve' ? 1 : 0,
          responseDate: new Date().toISOString(),
          responseRemarks: remarks.trim() || (approvalAction === 'approve' ? 'Approved' : 'Disapproved'),
          approvalLevel: userLevel
        };

        console.log("📤 Sending approval data:", approvalData);

        const approvalRes = await fetch(`${API_BASE_URL}api/SecondApproverPR`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(approvalData)
        });

        if (!approvalRes.ok) {
          const errorText = await approvalRes.text();
          console.error("❌ API Error Response:", errorText);
          throw new Error(`API Error: ${errorText}`);
        }

        const approvalResult = await approvalRes.json();
        console.log("✅ Approval submitted:", approvalResult);

        // ✅ UPDATE PR_Header STATUS
        console.log("🔄 Updating PR_Header status...");

        const prFetchRes = await fetch(`${API_BASE_URL}api/PR_Header/${selectedPR.id}`);

        if (!prFetchRes.ok) {
          console.warn("⚠️ Could not fetch PR data for status update");
        } else {
          const fullPRData = await prFetchRes.json();
          console.log("📦 Full PR Data:", fullPRData);

          let newStatus;

          if (approvalAction === 'disapprove') {
            newStatus = 3;
            console.log("❌ Setting status to 3 (Rejected)");
          } else {
            const allApprovalsRes = await fetch(`${API_BASE_URL}api/SecondApproverPR`);
            const allApprovals = await allApprovalsRes.json();
            const prApprovalsList = allApprovals.filter(
              a => a.prHeaderId === selectedPR.id && a.response === 1
            );

            const level2Approved = prApprovalsList.some(a => a.approvalLevel === 2);
            const level3Approved = prApprovalsList.some(a => a.approvalLevel === 3);

            if (level2Approved && level3Approved) {
              newStatus = 1;
              console.log("✅ All levels approved - Setting status to 1");
            } else {
              newStatus = 1;
              console.log("⏳ Still pending - Setting status to 1 (Pending)");
            }
          }

          const updatedPR = { ...fullPRData, status: newStatus };

          console.log("📤 Updating PR status to:", newStatus);

          const prUpdateRes = await fetch(`${API_BASE_URL}api/PR_Header/${selectedPR.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updatedPR)
          });

          if (!prUpdateRes.ok) {
            const errorText = await prUpdateRes.text();
            console.error("❌ PR Status Update Failed:", errorText);
          } else {
            console.log("✅ PR Status Updated Successfully to:", newStatus);
          }
        }

        // ✅ Log approve or disapprove
        await fetch(`${API_BASE_URL}api/Logs`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            action: approvalAction === 'approve' ? "APPROVE" : "DISAPPROVE",
            module: "Purchase Request",
            description: approvalAction === 'approve'
              ? `Approved PR #${selectedPR.id} at Level ${userLevel} (${userSession.positionId}). Remarks: ${remarks.trim() || 'Approved'}`
              : `Disapproved PR #${selectedPR.id} at Level ${userLevel} (${userSession.positionId}). Reason: ${remarks.trim()}`,
            userId: userSession.id || userSession.userId,
            username: userSession.username,
            fullName: userName || userSession.username,
          }),
        }).catch((err) => console.error("Log failed:", err));

        // ✅ Success messages
        if (approvalAction === 'approve') {
          if (userLevel === 3) {
            await Swal.fire({
              icon: "success",
              title: "PR Fully Approved!",
              html: `
                <p>✅ Level 2 (Endorsement) - Auto-approved</p>
                <p>✅ Level 3 (Acknowledgement) - Approved by you</p>
                <p class="mt-4 font-semibold text-green-600">This PR is now FULLY APPROVED!</p>
              `,
              timer: 4000
            });
          } else {
            await Swal.fire({
              icon: "success",
              title: `Level ${userLevel} Approved`,
              text: "Your approval has been recorded successfully.",
              timer: 3000
            });
          }
        } else {
          await Swal.fire({
            icon: "info",
            title: "PR Disapproved",
            text: "Purchase Request has been disapproved.",
            timer: 3000
          });
        }

        closeModal();
        fetchPRForApproval(currentUser);

      } catch (err) {
        console.error('❌ Error:', err);

        const userSession = JSON.parse(localStorage.getItem("user") || "{}");
        await fetch(`${API_BASE_URL}api/Logs`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            action: approvalAction === 'approve' ? "APPROVE-FAILED" : "DISAPPROVE-FAILED",
            module: "Purchase Request",
            description: `Failed to ${approvalAction} PR #${selectedPR.id}. Error: ${err.message}`,
            userId: userSession.id || userSession.userId,
            username: userSession.username,
            fullName: `${userSession.firstName} ${userSession.lastName}` || userSession.username,
          }),
        }).catch((logErr) => console.error("Log failed:", logErr));

        await Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: err.message
        });
      } finally {
        setSubmitting(false);
      }
    };

    const getApprovalLevelBadge = (prId) => {
      const levelMap = {
        2: {
          label: 'Pending: Level 2 - Endorsement',
          color: 'bg-yellow-100 text-yellow-800 border-2 border-yellow-300',
          icon: User,
          description: '⏳ Waiting for Endorsement approval'
        },
        3: {
          label: 'Pending: Level 3 - Acknowledgement',
          color: 'bg-blue-100 text-blue-800 border-2 border-blue-300',
          icon: Building,
          description: '✅ Endorsement approved → Waiting for Acknowledgement'
        },
        4: {
          label: '✓ Fully Approved',
          color: 'bg-green-100 text-green-800 border-2 border-green-300',
          icon: CheckCircle,
          description: '✅ All approval levels completed'
        }
      };

      const currentLevel = getPRPendingLevel(prId);
      const info = levelMap[currentLevel] || levelMap[2];
      const Icon = info.icon;

      return (
        <div className="flex flex-col gap-1">
          <span className={`inline-flex items-center gap-2 px-3 py-2 rounded-full text-xs font-bold ${info.color}`}>
            <Icon className="w-4 h-4" />
            {info.label}
          </span>
          <span className="text-xs text-slate-600 font-medium">{info.description}</span>
        </div>
      );
    };

    const formatDate = (dateString) => {
      if (!dateString) return 'N/A';
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    };

    if (loading) {
      return (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-600 border-t-transparent mx-auto mb-4"></div>
            <p className="text-blue-700 font-semibold text-lg">Loading PR Approvals...</p>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
          <div className="bg-white border border-red-200 rounded-2xl p-8 max-w-md shadow-2xl">
            <AlertCircle className="h-12 w-12 text-red-600 mx-auto mb-4" />
            <h3 className="text-xl font-bold text-red-900 text-center mb-3">Error Loading Data</h3>
            <p className="text-red-700 text-center mb-4">{error}</p>
            <button
              onClick={() => fetchPRForApproval(currentUser)}
              className="w-full bg-blue-600 text-white py-3 rounded-xl hover:bg-blue-700 transition-colors font-semibold shadow-lg flex items-center justify-center gap-2"
            >
              <RefreshCw className="w-5 h-5" />
              Retry
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-5">
        <div className="max-w-8xl mx-auto">
          {/* Header */}
          <div className="bg-white rounded-2xl p-8 shadow-lg mb-8 border border-blue-200">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl shadow-lg">
                  <CheckCircle className="w-8 h-8 text-white" />
                </div>
                <div>
                  <h1 className="text-3xl font-bold text-slate-800">PR Approval System</h1>
                  <p className="text-slate-600 mt-1">
                    {debugInfo?.userPosition || "Review and approve purchase requisitions"}
                  </p>
                </div>
              </div>
              <button
                onClick={() => fetchPRForApproval(currentUser)}
                className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl font-medium"
              >
                <RefreshCw className="w-5 h-5" />
                Refresh
              </button>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="bg-white rounded-xl shadow-md p-6 border border-yellow-200 hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-slate-600 mb-1 font-medium uppercase">Pending Level 2</p>
                  <p className="text-xs text-slate-500 mb-2">⏳ Endorsement Needed</p>
                  <p className="text-3xl font-bold text-yellow-600">
                    {prList.filter(pr => getPRPendingLevel(pr.id) === 2).length}
                  </p>
                </div>
                <div className="p-3 bg-yellow-100 rounded-xl">
                  <User className="h-7 w-7 text-yellow-600" />
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-md p-6 border border-blue-200 hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-slate-600 mb-1 font-medium uppercase">Pending Level 3</p>
                  <p className="text-xs text-slate-500 mb-2">⏳ Acknowledgement Needed</p>
                  <p className="text-3xl font-bold text-blue-600">
                    {prList.filter(pr => getPRPendingLevel(pr.id) === 3).length}
                  </p>
                </div>
                <div className="p-3 bg-blue-100 rounded-xl">
                  <Building className="h-7 w-7 text-blue-600" />
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-md p-6 border border-green-200 hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-slate-600 mb-1 font-medium uppercase">Fully Approved</p>
                  <p className="text-xs text-slate-500 mb-2">✅ All Levels Complete</p>
                  <p className="text-3xl font-bold text-green-600">
                    {prList.filter(pr => getPRPendingLevel(pr.id) === 4).length}
                  </p>
                </div>
                <div className="p-3 bg-green-100 rounded-xl">
                  <CheckCircle className="h-7 w-7 text-green-600" />
                </div>
              </div>
            </div>
          </div>

          {/* Search Filter */}
          <div className="bg-white rounded-xl shadow-md p-6 mb-8 border border-blue-200">
            <div className="relative">
              <input
                type="text"
                placeholder="Search by PR number or company..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-4 pr-4 py-3 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          </div>

          {/* PR List Table */}
          <div className="bg-white rounded-lg shadow-md border border-slate-200 overflow-hidden">
            {filteredPRs.length === 0 ? (
              <div className="p-12 text-center">
                <Package className="w-16 h-16 text-slate-300 mx-auto mb-4" />
                <p className="text-slate-600 font-medium text-lg">No purchase requisitions found</p>
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-slate-50 border-b border-slate-200">
                    <tr>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">PR No.</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Company</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Created By</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Date Created</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Date Needed</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Department</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Current Status</th>
                      <th className="px-6 py-4 text-center text-xs font-semibold text-slate-600 uppercase tracking-wider">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200">
                    {filteredPRs.map((pr) => (
                      <tr key={pr.id} className="hover:bg-slate-50 transition-colors">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex items-center gap-2">
                            <FileText className="w-4 h-4 text-blue-600" />
                            <span className="font-semibold text-blue-600">{pr.prNo}</span>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-700">
                          {companies[pr.companyId] || 'Unknown Company'}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-700">
                          {users[pr.createdBy] || `User ${pr.createdBy}`}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-700">
                          {formatDate(pr.creationDate)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-700">
                          {formatDate(pr.dateNeeded)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-700">
                          {departments[pr.chargedToDept] || 'N/A'}
                        </td>
                        <td className="px-6 py-4">
                          {getApprovalLevelBadge(pr.id)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <button
                            onClick={() => handleViewDetails(pr)}
                            className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium"
                          >
                            <Eye className="w-4 h-4" />
                            View
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        {/* Approval Modal */}
        {showModal && selectedPR && (
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
              <div className="sticky top-0 bg-gradient-to-r from-blue-600 to-indigo-600 text-white z-20 flex justify-between items-center p-6 rounded-t-2xl">
                <div>
                  <h2 className="text-2xl font-bold">PR Approval - {selectedPR.prNo}</h2>
                  <p className="text-blue-100 text-sm mt-1">Review and process purchase requisition</p>
                </div>
                <button onClick={closeModal} className="p-2 hover:bg-white/20 rounded-lg transition-colors">
                  <X className="h-6 w-6" />
                </button>
              </div>

              <div className="p-8">
                {/* PR Header Info */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-base">
            {[
              ["Requestor", selectedPR.requestor || "—"],
              ["Date Needed", formatDate(selectedPR.dateNeeded)],
              ["Date Submitted", formatDate(selectedPR.dateSubmittedForApproval)],
              ["Priority", selectedPR.priority || "—"],
            ].map(([label, value]) => (
              <div key={label} className="flex gap-2">
                <span className="font-semibold text-gray-700 min-w-[160px]">{label}:</span>
                <span className="text-gray-600 break-words">{value}</span>
              </div>
            ))}
          </div>

                {/* PR Items Table */}
                <div className="mb-6">
                  <h3 className="text-xl font-bold text-slate-800 mb-4">Items Requested</h3>
                  <div className="overflow-x-auto shadow-md rounded-lg border border-slate-200">
                    <table className="w-full">
                      <thead className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
                        <tr>
                          <th className="px-4 py-3 text-left text-sm font-semibold">#</th>
                          <th className="px-4 py-3 text-left text-sm font-semibold">Item</th>
                          <th className="px-4 py-3 text-left text-sm font-semibold">Specification</th>
                          <th className="px-4 py-3 text-center text-sm font-semibold">Qty</th>
                          <th className="px-4 py-3 text-center text-sm font-semibold">UOM</th>
                          <th className="px-4 py-3 text-right text-sm font-semibold">Unit Price</th>
                          <th className="px-4 py-3 text-right text-sm font-semibold">Total</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-200 bg-white">
                        {prDetails.length > 0 ? (
                          prDetails.map((item, idx) => (
                            <tr key={idx} className="hover:bg-blue-50 transition-colors">
                              <td className="px-4 py-3 text-sm">{idx + 1}</td>
                              <td className="px-4 py-3 text-sm">{item.itemDescription || 'N/A'}</td>
                              <td className="px-4 py-3 text-sm">{item.materialFinish || item.purpose || '—'}</td>
                              <td className="px-4 py-3 text-sm text-center">{item.qty || 0}</td>
                              <td className="px-4 py-3 text-sm text-center">{item.uom || 'N/A'}</td>
                              <td className="px-4 py-3 text-sm text-right">₱{(item.unitPrice || 0).toFixed(2)}</td>
                              <td className="px-4 py-3 text-sm text-right font-semibold">₱{(item.costEstimate || 0).toFixed(2)}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="px-4 py-8 text-center text-slate-500">No items found</td>
                          </tr>
                        )}
                      </tbody>
                      {prDetails.length > 0 && (
                        <tfoot className="bg-slate-100">
                          <tr>
                            <td colSpan="6" className="px-4 py-3 text-right font-bold">GRAND TOTAL:</td>
                            <td className="px-4 py-3 text-right font-bold text-green-700 text-lg">
                              ₱{prDetails.reduce((sum, item) => sum + (item.costEstimate || 0), 0).toFixed(2)}
                            </td>
                          </tr>
                        </tfoot>
                      )}
                    </table>
                  </div>
                </div>

                {/* Permission Warning */}
                {!canApprovePR && denialReason && (
                  <div className="bg-red-50 border-2 border-red-300 rounded-lg p-4 mb-6">
                    <div className="flex items-center gap-3">
                      <AlertCircle className="w-6 h-6 text-red-600" />
                      <div>
                        <h4 className="font-bold text-red-900">Cannot Approve</h4>
                        <p className="text-red-800 text-sm">{denialReason}</p>
                      </div>
                    </div>
                  </div>
                )}

                {/* Approval Signature Slots */}
                <div className="flex flex-row flex-wrap justify-between gap-6 w-full mb-8">
                  {signatureSlots.map((slot, idx) => {
                    const approval = slot.approval;
                    const userDetail = approval
                      ? approverDetails[approval.actualApproverId]
                      : null;

                    const fullName =
                      slot.level === 1
                        ? slot.name
                        : approval?.actualApproverName ||
                          (userDetail
                            ? `${userDetail.firstName} ${userDetail.lastName}`
                            : "—");

                    const signatureImg =
                      slot.level === 1
                        ? slot.signature
                        : approverSignatures[approval?.actualApproverId];

                    const date =
                      slot.level === 1
                        ? slot.date
                        : approval?.responseDate;

                    return (
                      <div
                        key={idx}
                        className="flex flex-col items-center flex-1 min-w-[250px]"
                      >
                        {/* Signature Image */}
                        {signatureImg ? (
                          <img
                            src={signatureImg}
                            alt={`${fullName} Signature`}
                            className="h-16 object-contain mb-2"
                          />
                        ) : (
                          <div className="h-16 w-full border-b border-dashed border-slate-300 mb-2" />
                        )}

                        {/* Name / Dropdown */}
                        {slot.level === 2 && !slot.approval ? (
                          <div className="relative w-full" ref={dropdownRef}>
                            <input
                              type="text"
                              value={requestorSearch}
                              onChange={(e) => {
                                setRequestorSearch(e.target.value);
                                setShowRequestorDropdown(true);

                                if (!e.target.value)
                                  setEndorsementRequestor(null);
                              }}
                              onFocus={() => setShowRequestorDropdown(true)}
                              placeholder="Search endorser..."
                              className="w-full px-3 py-2 border-2 border-blue-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 text-center font-medium bg-blue-50 placeholder-slate-400"
                            />

                            {showRequestorDropdown && (
                              <div className="absolute z-50 w-full bg-white border border-slate-200 rounded-lg shadow-lg max-h-48 overflow-y-auto mt-1">
                                {requestorList
                                  .filter(
                                    (r) =>
                                      r.name
                                        .toLowerCase()
                                        .includes(requestorSearch.toLowerCase()) ||
                                      (r.department || "")
                                        .toLowerCase()
                                        .includes(requestorSearch.toLowerCase())
                                  )
                                  .map((r) => (
                                    <div
                                      key={r.id}
                                      onClick={() => {
                                        setEndorsementRequestor(r);
                                        setRequestorSearch(r.name);
                                        setShowRequestorDropdown(false);
                                      }}
                                      className="px-3 py-2 hover:bg-blue-50 cursor-pointer text-sm text-left"
                                    >
                                      <p className="font-medium text-slate-800">
                                        {r.name}
                                      </p>
                                      <p className="text-xs text-slate-500">
                                        {r.department}
                                      </p>
                                    </div>
                                  ))}

                                {requestorList.filter((r) =>
                                  r.name
                                    .toLowerCase()
                                    .includes(requestorSearch.toLowerCase())
                                ).length === 0 && (
                                  <div className="px-3 py-2 text-sm text-slate-400">
                                    No results found
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        ) : (
                          <p className="font-medium text-slate-800 text-center">
                            {fullName}
                          </p>
                        )}

                        {/* Line */}
                        <div className="w-full border-t-2 border-slate-400 my-2"></div>

                        <p className="text-xs text-slate-400 italic text-center">
                          Signature over Printed Name
                        </p>

                        <p className="text-sm font-bold text-slate-700 mt-1 uppercase tracking-wide text-center">
                          {slot.position}
                        </p>

                        {date && (
                          <p className="text-xs text-blue-500 mt-1 font-medium text-center">
                            {formatDate(date)}
                          </p>
                        )}
                      </div>
                    );
                  })}
                </div>

                {/* Approval Action Section */}
                {canApprovePR && (
                  <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-6 border-2 border-blue-300 shadow-lg">
                    <h3 className="text-xl font-bold text-slate-800 mb-4 flex items-center gap-2">
                      <MessageSquare className="w-6 h-6 text-blue-600" />
                      Approval Decision
                    </h3>

                    <div className="space-y-4">
                      <div className="grid grid-cols-2 gap-4">
                        <button
                          onClick={() => setApprovalAction('approve')}
                          className={`flex items-center justify-center gap-3 px-6 py-4 rounded-xl font-bold transition-all shadow-md ${approvalAction === 'approve'
                            ? 'bg-green-600 text-white shadow-lg scale-105'
                            : 'bg-white border-2 border-green-600 text-green-600 hover:bg-green-50'
                            }`}
                        >
                          <CheckCircle className="w-6 h-6" />
                          Approve
                        </button>
                        <button
                          onClick={() => setApprovalAction('disapprove')}
                          className={`flex items-center justify-center gap-3 px-6 py-4 rounded-xl font-bold transition-all shadow-md ${approvalAction === 'disapprove'
                            ? 'bg-red-600 text-white shadow-lg scale-105'
                            : 'bg-white border-2 border-red-600 text-red-600 hover:bg-red-50'
                            }`}
                        >
                          <XCircle className="w-6 h-6" />
                          Disapprove
                        </button>
                      </div>

                      <div>
                        <label className="block text-sm font-semibold text-slate-700 mb-2">
                          Remarks {approvalAction === 'disapprove' && <span className="text-red-600">*</span>}
                        </label>
                        <textarea
                          value={remarks}
                          onChange={(e) => setRemarks(e.target.value)}
                          placeholder={
                            approvalAction === 'disapprove'
                              ? 'Please provide reason for disapproval...'
                              : 'Add your remarks (optional)...'
                          }
                          rows={4}
                          className="w-full px-4 py-3 border-2 border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
                        />
                      </div>

                      <button
                        onClick={handleApprovalSubmit}
                        disabled={submitting || !approvalAction}
                        className={`w-full flex items-center justify-center gap-3 px-6 py-4 rounded-xl transition-all shadow-lg hover:shadow-xl font-bold disabled:opacity-50 disabled:cursor-not-allowed ${approvalAction === 'approve'
                          ? 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white'
                          : approvalAction === 'disapprove'
                            ? 'bg-gradient-to-r from-red-600 to-rose-600 hover:from-red-700 hover:to-rose-700 text-white'
                            : 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white'
                          }`}
                      >
                        {submitting ? (
                          <>
                            <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                            Processing...
                          </>
                        ) : (
                          <>
                            <Send className="w-6 h-6" />
                            Submit {approvalAction === 'approve' ? 'Approval' : approvalAction === 'disapprove' ? 'Disapproval' : 'Decision'}
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  export default SecondPR_Approval;